import { render, staticRenderFns } from "./DatosGenerales.vue?vue&type=template&id=6f5d9314&"
import script from "./DatosGenerales.vue?vue&type=script&lang=ts&"
export * from "./DatosGenerales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6f5d9314', component.options)
    } else {
      api.reload('6f5d9314', component.options)
    }
    module.hot.accept("./DatosGenerales.vue?vue&type=template&id=6f5d9314&", function () {
      api.rerender('6f5d9314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudBajaCliente/Crear/DatosGenerales.vue"
export default component.exports